module.exports = __webpack_public_path__ + "fonts/Montserrat-regular_3bc90003d4868fece8724afd1e624366.ttf";